import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var TMKey;
(function (TMKey) {
    TMKey.get = createAccessors(arrayGetSet('tm_keys'), {
        name: 'Ключ',
        serial: '',
        touch_actions: [],
    });
})(TMKey || (TMKey = {}));
